import React, { FC } from 'react';
import { ReactComponent as EmptyBoxIcon } from 'src/assets/images/onboarding-trainer/dashboard/profile/packages/empty-package/empty-package-box.svg';
import { ReactComponent as PlusIcon } from 'src/assets/images/onboarding-trainer/dashboard/profile/packages/empty-package/add-plus.svg';
import './EmptyPackagesView.scss';

interface EmptyPackagesViewProps {
  onCreateClick: () => void;
}

export const EmptyPackagesView: FC<EmptyPackagesViewProps> = ({ onCreateClick }) => {
  return (
    <div className="empty-packages-container">
      <div className="empty-packages-card">
        <div className="empty-icon-wrap">
          <EmptyBoxIcon className="empty-box-svg" />
        </div>

        <h2 className="empty-title">{'No package yet'}</h2>
        <p className="empty-subtitle">{'Create a package and start earning'}</p>

        <button type="button" className="btn-create-package-white" onClick={onCreateClick}>
          <PlusIcon className="btn-plus-icon" />
          <span>{'Create a Package'}</span>
        </button>
      </div>
    </div>
  );
};
